<script>
import { layoutComputed } from "@/state/helpers";
// import Vertical from "./vertical";
import Horizontal from "./horizontal";

export default {
  components: { /*Vertical ,*/ Horizontal },
  computed: {
    ...layoutComputed
  },
  methods: {}
};
</script>

<template>
  <div class="tmp-hide">  
    <!-- d-none d-lg-block -->
    <!-- <Vertical v-if="layoutType === 'vertical'" :layout="layoutType">
      <slot />
    </Vertical> -->
    <Horizontal v-if="layoutType === 'vertical'" :layout="layoutType" >
      <slot />
    </Horizontal>
  </div>
</template>

<style >


  /*@media screen and (min-width: 1390px) {
    .zoom-container {
        zoom: 100%;
    } 
  }

  @media screen and (max-width: 1390px) {
    .zoom-container {
        zoom: 75%;
    } 

  }

  @media screen and (max-width: 800px) {
    .zoom-container {
        zoom: 60%;
    }
  } 

  @media screen and (max-width: 500px) {
    .zoom-container {
        zoom: 100%;
    } 
  }*/

</style>
